
import { RouteObject } from 'react-router-dom';
import { lazy, ReactElement } from 'react';
import React from 'react';

// Lazy‑load page components
const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const DigitalDashboardDetailsPage = lazy(() => import('../pages/digital-dashboard-details/page'));
const CarMultimediaDetailsPage = lazy(() => import('../pages/car-multimedia-details/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

/**
 * Routes configuration.
 * Each route renders a lazily‑loaded component.
 * Wrapping the routes with a <React.Suspense> fallback
 * (usually done at a higher level) will handle the loading state.
 */
const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/digital-dashboard-details',
    element: <DigitalDashboardDetailsPage />,
  },
  {
    path: '/car-multimedia-details',
    element: <CarMultimediaDetailsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
